import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import store from '@/store';
import router from '@/router';
import { CogIcon, LogoutIcon } from '@heroicons/vue/outline';
import BaseTemplate from '@/views/templates/BaseTemplate.vue';
import { NavigationGetters } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppTemplate',
  setup(__props) {

const sideNavigationItems = computed(() => store.getters[NavigationGetters.SIDE_NAVIGATION_ITEMS]);
const showLogout = computed(() => location.host !== 'embed.mobcall.com');

const handleConfigClick = () => {
    router.push('/settings');
};

const handleLogoutClick = () => {
    router.push('/logout');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseTemplate, {
    "navigation-items": sideNavigationItems.value,
    "router-key": _ctx.$route.fullPath
  }, {
    headerActions: _withCtx(() => [
      _createElementVNode("button", {
        class: "text-primary hover:text-primary-400 mr-2",
        onClick: handleConfigClick
      }, [
        _createVNode(_unref(CogIcon), {
          class: "h-6 w-6",
          "aria-hidden": "true"
        })
      ]),
      (showLogout.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "text-primary hover:text-primary-400",
            onClick: handleLogoutClick
          }, [
            _createVNode(_unref(LogoutIcon), {
              class: "h-6 w-6",
              "aria-hidden": "true"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["navigation-items", "router-key"]))
}
}

})